<template>
  <div class="equipment">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1 class="_kanji">設備一覧</h1>
        </div>
				<p  id="DetailHeadUpSp">
本社工場、城南島工場で現在稼働している機器及びソフトウェアリストです。
				</p>
      </div>
    </div>

		<div v-show="checkHideContents(SecondLayer)">
			<div class="container">
				<div class="rowView">
					<sort-panel @parentMethod="updateList" :origin=originList :page-range="50" :page-num=currentPage :list-header="setListHeader" v-if="setListPanel"></sort-panel>
					<any-list @createDetail="createDetail" :display-list="displayList" :any-list="1"></any-list>
				</div>
			</div>
		</div>

		<router-view v-on:changeDetail="setDetail"></router-view>
  </div>
</template>

<script>
import sortPanel from '@/components/SortPanel.vue'
import anyList from '@/components/AnyList.vue'
//const originList = require('@/../public/asset/data/equipment.json')

export default {
  name: 'equipment',
  components:{
    sortPanel, 
		anyList,
  },
  data: function () {
    return {
      originList:[],
      displayList:[],
			orderList:[],
			currentPage:1,
      detailIndex:0,
			detailName:'',
			listHeader:[
{title:"工程", element:"process"},
{title:"機械名称", element:"title"},
{title:"メーカー", element:"maker"},
{title:"", element:"image"},
{title:"備考", element:"remarks"},
{title:"設置", element:"factory"},
{title:"台数", element:"number"}],
			pageTitle:"設備一覧",
			description:"会社の規模拡大とともに設備投資を行い、新しい機器、技術でご依頼に対応できる体制でお待ちしております",
			keywords:"設備一覧",
			ogType:"article",
    }
  },
  computed: {
		setListHeader:function() {
			return this.listHeader
		},
		setListPanel:function() {
/*直呼び出しの場合、jsonが揃ってから構築しないと、再構築してくれない。
リストなしで構築要求があった場合は、作成しないようにする*/
			return this.originList.length > 0
		},
	},
  beforeMount:function() {this._log("beforeMount "+this.$options.name)
//ページ初期構築時の情報をセットする
    this.setList()
		if(this.$route.query.list) {
			this.currentPage = Number(this.$route.query.list)
		}
  },
  mounted: function() {this._log("mounted "+this.$options.name)
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')
	
/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/business/equipment?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
		}
  },
  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)

/*ブラウザー戻る進む処理変化の場合は、欠損するデータを補う*/
/*vue-routerで指定するやり方では動かず*/
		if(this.$route.params.anyList == undefined) {
			this.$route.params.anyList = 1 //セットできる プロパティもある状態でセット可能
		}
		if(this.$route.params.detail == undefined) {
			this.detailName = this.$route.params.pageId
			let aIndex =  this.displayList.findIndex(({title}) => title === this.detailName)
			this.detailIndex = aIndex
      let aImg = this.displayList[aIndex]
			this.$route.params.detail  = aImg
		}

		if(this.$route.query.list) {
/*ブラウザーリロード処理変化の場合は、urlに合わせたリスト表示を更新する必要がある*/
			let aPageNumber = Number(this.$route.query.list)
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
			}
		} else {
				this.currentPage = 1
		}
	},
  updated:function() {this._log("updated "+this.$options.name)

		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/business/equipment?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
		}
  },
  methods:{
    createDetail(aImg, index){
      this.detailIndex = index
      this.$router.push({
          name: '設備詳細',
          params: { 
              pageId:aImg.title,
              anyList:1,
              detail:aImg,
          }
      })
    },
    setDetail:function(aFor) {
      this.detailIndex += aFor
      if(this.orderList.length <= this.detailIndex) {
        this.detailIndex = 0
      } else if(this.detailIndex < 0 ) {
        this.detailIndex = this.orderList.length-1
      }
      let aImg = this.orderList[this.detailIndex]
      this.$router.push({
          name: '設備詳細',
          params: { 
              pageId:aImg.title,
              anyList:1,
              detail:aImg
          }
      })
    },
    setList() {
			if(this.$store.getters.originListEquipment .length == 0 ) {
				/*データがない場合は、storeの状態を監視して、読み込み終了とともにセットする*/
				this.detailName = decodeURI(this.$route.path.match(/([^\/.]+)/g).pop())
				if(this.detailName != 'equipment') {
/*詳細ページの場合は一度、リストページに戻す*/
					this.$router.push({path:"/business/equipment?list=1"})
				}else{
/*リストページの場合*/
					this.detailName = ''
				}
				this.$store.watch(
					(state, getters) => getters.originListEquipment,
					(newValue, oldValue) => {
						this.originList = this.$store.getters.originListEquipment
						this.resetList()
/*詳細ページの場合は以下が必要*/
						if(this.detailName != '') {
							this.rePushDetail()
						}
					}
				)
			} else {
				this.originList = this.$store.getters.originListEquipment
				this.resetList()
			}
    },
    resetList() {
      this.displayList = Object.assign([], this.originList)
			this.orderList = Object.assign([], this.originList)
    },
    updateList(aDisplayList, aDisplayListAll, aPageNumber) {
/*子から呼び出す表示更新メソッド*/
      this.displayList = aDisplayList
			this.orderList = aDisplayListAll
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
				this.$router.push({
          name: '設備一覧',
          query: { 
              list:aPageNumber,
          }
				})
			}
    },
		rePushDetail() {
			let aIndex =  this.displayList.findIndex(({title}) => title === this.detailName)
			this.detailIndex = aIndex
      let aImg = this.displayList[aIndex]
      this.$router.push({
          name: '設備詳細',
          params: { 
              pageId:aImg.title,
              anyList:1,
              detail:aImg
          }
      })
		},
  },
}
</script>


<style>
</style>
